import { clsx } from "clsx"
import { forwardRef } from "react"

import { theme, type ThemeKeys } from "../../theme"
import { textStyles, textVariantMapping } from "../Text"
import styles from "./EditableText.module.css"

export interface EditableTextProps {
  "aria-label": string
  value: string
  color?: ThemeKeys<"color">
  variant?: keyof typeof textVariantMapping
  disabled?: boolean
  onBlur?: () => void
  onChange?: (value: string) => void
}

export const EditableText = forwardRef<HTMLDivElement, EditableTextProps>(
  function EditableText(props, ref) {
    const {
      "aria-label": ariaLabel,
      onChange,
      color = "grey12",
      variant = "normal",
      ...otherProps
    } = props

    const className = clsx(styles.input, textStyles[`variant-${variant}`])

    return (
      <div ref={ref} className={styles.editableText}>
        <input
          {...otherProps}
          aria-label={ariaLabel}
          className={className}
          style={{ color: theme.color[color] }}
          onChange={(evt) => onChange?.(evt.currentTarget.value)}
          inputMode="text"
        />
      </div>
    )
  },
)
